import { useState } from 'react';

import { Button } from '@playbooks/ui/components/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@playbooks/ui/components/dropdown-menu';
import { FarIcon } from '@playbooks/ui/components/icon';
import { InputGroupTrigger } from '@playbooks/ui/components/input-group';
import { capitalize } from '@playbooks/utils';

const BasicSelectDrop = ({
	id,
	value,
	prevIcon = null,
	placeholder = '',
	options = [],
	labels = {},
	descriptions = {},
	taskRunning = false,
	size = 'default',
	onChange,
	hasClear = false,
	className = '',
}: {
	id: string;
	value: any;
	prevIcon?: any;
	placeholder?: string;
	options?: any[];
	labels?: Record<string, string>;
	descriptions?: Record<string, string | undefined>;
	taskRunning?: boolean;
	size?: 'xs' | 'sm' | 'default' | 'lg';
	onChange: (value: any) => void;
	hasClear?: boolean;
	className?: string;
}) => {
	const [open, setOpen] = useState(false);
	const select = nextValue => {
		onChange(nextValue);
		setOpen(false);
	};
	return (
		<DropdownMenu open={open} onOpenChange={setOpen}>
			<DropdownMenuTrigger
				render={
					<InputGroupTrigger id={id} prevIcon={prevIcon} size={size} isLoading={taskRunning} className={className}>
						<span className='min-w-0 truncate'>{value ? labels[value] || capitalize(value) : placeholder}</span>
					</InputGroupTrigger>
				}
			/>
			<DropdownMenuContent align='start' className='w-max min-w-[var(--anchor-width)]'>
				{options.map(option => (
					<Button
						key={option}
						type='button'
						variant='ghost'
						onClick={() => select(value !== option ? option : '')}
						className='h-auto w-full justify-between py-2 text-left'>
						<span className='flex min-w-0 flex-col items-start'>
							<span>{labels[option] || (option ? capitalize(option) : placeholder)}</span>
							{descriptions[option] ? (
								<span className='max-w-72 whitespace-normal text-xs font-normal text-foreground-body'>
									{descriptions[option]}
								</span>
							) : null}
						</span>
						{value === option ? <FarIcon icon='check' className='size-3' aria-hidden /> : null}
					</Button>
				))}
				{hasClear ? (
					<Button type='button' variant='ghost' onClick={() => select('')} className='w-full justify-between'>
						Clear
					</Button>
				) : null}
			</DropdownMenuContent>
		</DropdownMenu>
	);
};
export { BasicSelectDrop };
